import { client } from './client'
const axios = client()
import {
  EVENTS,
  FETCHING_EVENTS,
  TRAINERS,
  EVENTDETAILS,
  NEXTEVENTDATE,
  EVENT_DOT_DATES,
  CLASS_FILTER_EVENTS,
  BOOK,
  CLEARSTATUS,
  CLASSES,
  ROOMS,
  SETFROMEVENT,
  CLEARFROMEVENT
} from 'Constants'
import moment from 'moment-timezone'
import { API_ROOT } from 'Config'
import { store } from '../store.index'
import { trackEvent } from '../utils/helper'
import { bookee_booked_class, eventCategoryOptions } from '../constants/events'

let getAxiosConfig = () => {
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('customerkey')
    }
  }
}

export function setFromEvent(uri, eventData, isAppointment = false) {
  return dispatch =>
    dispatch({
      type: SETFROMEVENT,
      payload: { uri, eventData, isAppointment }
    })
}
export function clearFromEvent() {
  return dispatch =>
    dispatch({
      type: CLEARFROMEVENT
    })
}
export function clearStatus() {
  return dispatch =>
    dispatch({
      type: CLEARSTATUS,
      payload: ''
    })
}

export function startFetchingEvents(timestamp) {
  return {
    type: FETCHING_EVENTS,
    timestamp
  }
}

export function getEvents(postData, timestamp) {
  // Hotfix for instagram in-app browser + iOS navigation issue
  const inferredRegionId = postData.region_id
    ? postData.region_id
    : localStorage.getItem('region_id')
  const inferredUrlPrefix =
    window.location.hostname !== 'localhost'
      ? window.location.hostname?.split('.')?.[0] ?? null
      : localStorage.getItem('url_prefix')

  if (!inferredRegionId || !inferredUrlPrefix) {
    return dispatch => {
      dispatch({ type: EVENTS, payload: '', timestamp })
    }
  }

  const settings = store.getState().centerreducer.regionsDetails.regions[0]
    .centers[0].settings

  const combinedCalendar = settings?.combined_calendar

  if (combinedCalendar) {
    postData.include_courses = true
  }

  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: inferredRegionId,
    url_prefix: inferredUrlPrefix || store.getState().accountreducer.urlPrefix
  }
  let requestUrl = ''
  if (postData.filters.created_at !== undefined) {
    requestUrl = `${API_ROOT}/api/embed/events?date=${postData.filters.created_at}`
  } else {
    requestUrl = `${API_ROOT}/api/embed/events`
  }
  let request = axios.post(requestUrl, postData, axiosConfig)

  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({
          type: EVENTS,
          payload: data.data,
          timestamp,
          postData
        })
      })
      .catch(err => {
        dispatch({ type: EVENTS, payload: err, timestamp })
      })
  }
}

// Fetches events filtered by location + class ONLY (no instructor/facility) so
// the Instructor/Facility filter dropdowns can list every option for the
// selected class(es) regardless of which instructor/facility is selected.
// Kept separate from getEvents so it never narrows (or is narrowed by) the
// schedule list, and writes to its own reducer slice (classFilterEvents).
export function getClassFilterEvents(postData) {
  const inferredRegionId = postData.region_id
    ? postData.region_id
    : localStorage.getItem('region_id')
  const inferredUrlPrefix =
    window.location.hostname !== 'localhost'
      ? window.location.hostname?.split('.')?.[0] ?? null
      : localStorage.getItem('url_prefix')

  if (!inferredRegionId || !inferredUrlPrefix) {
    return dispatch => {
      dispatch({ type: CLASS_FILTER_EVENTS, payload: [] })
    }
  }

  const settings = store.getState().centerreducer.regionsDetails.regions[0]
    .centers[0].settings
  if (settings?.combined_calendar) {
    postData.include_courses = true
  }

  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: inferredRegionId,
    url_prefix: inferredUrlPrefix || store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/events`
  const request = axios.post(requestUrl, postData, axiosConfig)

  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: CLASS_FILTER_EVENTS, payload: data.data })
      })
      .catch(() => {
        dispatch({ type: CLASS_FILTER_EVENTS, payload: [] })
      })
  }
}

// Clears the Instructor/Facility option source without hitting the network.
// Used when no class is selected: the dropdowns then fall back to the full
// location-scoped trainer/room lists, so there's no need to fetch (and no need
// to pull the entire calendar_view event set just to populate two dropdowns).
export function clearClassFilterEvents() {
  return dispatch => {
    dispatch({ type: CLASS_FILTER_EVENTS, payload: [] })
  }
}

export function getEventsDetails(postData) {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    include_zero_credits: 1
  }

  let requestUrl = `${API_ROOT}/api/embed/events/${postData.event_id}`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: EVENTDETAILS, payload: data.data.event })
      })
      .catch(err => {
        dispatch({ type: EVENTDETAILS, payload: err })
      })
  }
}

export function getNextEventDates(postData) {
  // Hotfix for instagram in-app browser + iOS navigation issue
  const inferredRegionId = postData.region_id
    ? postData.region_id
    : localStorage.getItem('region_id')
  const inferredUrlPrefix =
    window.location.hostname !== 'localhost'
      ? window.location.hostname?.split('.')?.[0] ?? null
      : localStorage.getItem('url_prefix')

  if (!inferredRegionId || !inferredUrlPrefix) {
    return dispatch => {
      dispatch({ type: NEXTEVENTDATE, payload: null })
    }
  }

  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: inferredRegionId,
    url_prefix: inferredUrlPrefix || store.getState().accountreducer.urlPrefix
  }

  // PIC-1087: send center_id in the query string too so the backend can
  // reliably scope the lookup to the user-selected location(s), even if
  // the JSON-body `filters` object isn't picked up downstream.
  const centerIdsFilter = postData?.filters?.center_id
  if (Array.isArray(centerIdsFilter) && centerIdsFilter.length > 0) {
    axiosConfig.params.center_id = centerIdsFilter.join(',')
  }

  let requestUrl = `${API_ROOT}/api/embed/next-event-date`
  let request = axios.post(requestUrl, postData, axiosConfig)

  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({
          type: NEXTEVENTDATE,
          payload: {
            next_event_date: data.data.next_event_date,
            next_bookable_event_date: data.data.next_bookable_event_date
          }
        })
      })
      .catch(() => {
        dispatch({ type: NEXTEVENTDATE, payload: null })
      })
  }
}

export const getEventEligibility = postData => {
  const axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id:
      localStorage.getItem('selected_center_id') ||
      localStorage.getItem('center_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/prerequisites/eligibility`
  return axios.post(requestUrl, postData, axiosConfig)
}

export const confirmEventWaitlistSlot = eventId => {
  const axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id:
      localStorage.getItem('selected_center_id') ||
      localStorage.getItem('center_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/events/${eventId}/confirm`
  return axios.get(requestUrl, axiosConfig)
}

export const getBookingRulesEligibility = postData => {
  const axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id:
      localStorage.getItem('selected_center_id') ||
      localStorage.getItem('center_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/booking_rules/eligibility`
  return axios.post(requestUrl, postData, axiosConfig)
}

export function getTrainers(center_ids = []) {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    service_id: '3',
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  if (center_ids.length > 0) {
    axiosConfig.params.center_ids = center_ids.join(',')
  }

  let requestUrl = `${API_ROOT}/api/embed/trainers`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        // Sort trainers by first name
        data.data.users.sort((a, b) => {
          let nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })

        dispatch({ type: TRAINERS, payload: data.data.users })
      })
      .catch(err => {
        dispatch({ type: TRAINERS, payload: err })
      })
  }
}
export function getRooms(center_ids = []) {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  if (center_ids.length > 0) {
    axiosConfig.params.center_ids = center_ids.join(',')
  }

  let requestUrl = `${API_ROOT}/api/embed/facilities`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: ROOMS, payload: data.data.facilities })
      })
      .catch(err => {
        dispatch({ type: ROOMS, payload: err })
      })
  }
}
export function getClasses(center_ids = []) {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    include_detached: 1
  }

  if (center_ids.length > 0) {
    axiosConfig.params.center_ids = center_ids.join(',')
  }

  let requestUrl = `${API_ROOT}/api/embed/classes`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: CLASSES, payload: data.data.classes })
      })
      .catch(err => {
        dispatch({ type: CLASSES, payload: err })
      })
  }
}

export function bookEvent(postData) {
  let axiosConfig = getAxiosConfig()

  let requestUrl = ''

  let reqBody = {
    center_contact_id: postData.center_id,
    event_id: postData.event_id,
    payment: {
      amount: postData.free ? 0 : postData.event_id,
      payment_method: postData.free ? 'cash' : 'credit',
      payment_mode: 'offline',
      credit_id: postData.credit_id
    },
    url_prefix: store.getState().accountreducer.urlPrefix,
    ...(postData.spot_id && { spot_id: postData.spot_id })
  }
  if (postData.book_for) {
    reqBody.book_for = postData.book_for
  }
  if (postData.friendData) {
    reqBody.friend_contacts = postData.friendData
  }
  if (postData.friend_contacts_count) {
    reqBody.friend_contacts_count = postData.friend_contacts_count
    reqBody.friend_contacts = postData.friend_contacts
  }
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  requestUrl = `${API_ROOT}/api/embed/events/${postData.event_id}/book`
  let request = axios.post(requestUrl, reqBody, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: BOOK, payload: data })

        trackEvent(
          {
            category: eventCategoryOptions.actionName,
            action: 'Books a class',
            label: bookee_booked_class
          },
          { name: postData.name }
        )
      })
      .catch(err => {
        dispatch({ type: BOOK, payload: err.response?.data })
      })
  }
}

export const verifyFriendsEmail = data => {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    center_id:
      localStorage.getItem('selected_center_id') ||
      localStorage.getItem('center_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    region_id: localStorage.getItem('region_id')
  }
  let requestUrl = `${API_ROOT}/api/embed/events/friend/check`
  return axios.post(requestUrl, data, axiosConfig)
}

export const getEventSpotLayout = eventId => {
  return async dispatch => {
    try {
      let axiosConfig = getAxiosConfig()
      axiosConfig.params = {
        center_id:
          localStorage.getItem('selected_center_id') ||
          localStorage.getItem('center_id'),
        url_prefix: store.getState().accountreducer.urlPrefix,
        region_id: localStorage.getItem('region_id')
      }

      const response = await axios.get(
        `${API_ROOT}/api/embed/events/${eventId}/spots`,
        axiosConfig
      )

      if (response.data.status === 'error') {
        throw new Error(response.data.message || 'Failed to load spot layout')
      }

      dispatch({
        type: 'GET_EVENT_SPOT_LAYOUT_SUCCESS',
        payload: response
      })

      return response.data
    } catch (error) {
      dispatch({
        type: 'GET_EVENT_SPOT_LAYOUT_ERROR',
        payload: error.message || 'Failed to load spot layout'
      })
      throw error
    }
  }
}

export const validateGroupGuests = data => {
  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  let requestUrl = `${API_ROOT}/api/embed/events/guests/eligibility`
  return axios.post(requestUrl, data, axiosConfig)
}

export function getEventDates(postData) {
  const inferredRegionId = postData.region_id
    ? postData.region_id
    : localStorage.getItem('region_id')
  const inferredUrlPrefix =
    window.location.hostname !== 'localhost'
      ? window.location.hostname?.split('.')?.[0] ?? null
      : localStorage.getItem('url_prefix')

  if (!inferredRegionId || !inferredUrlPrefix) {
    return dispatch => {
      dispatch({ type: EVENT_DOT_DATES, payload: [] })
    }
  }

  const settings = store.getState().centerreducer.regionsDetails?.regions?.[0]
    ?.centers?.[0]?.settings

  const combinedCalendar = settings?.combined_calendar

  if (combinedCalendar) {
    postData.include_courses = true
  }

  let axiosConfig = getAxiosConfig()
  axiosConfig.params = {
    region_id: inferredRegionId,
    url_prefix: inferredUrlPrefix || store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/events?dates_only=true`
  let request = axios.post(requestUrl, postData, axiosConfig)

  return dispatch => {
    dispatch({ type: EVENT_DOT_DATES, payload: [] })
    request
      .then(({ data }) => {
        // Handle different possible response structures
        let eventDates = data?.data?.event_dates || data?.event_dates || []
        // Ensure all dates are in YYYY-MM-DD format
        if (eventDates.length > 0) {
          eventDates = eventDates.map(date => moment(date).format('YYYY-MM-DD'))
          // Remove any duplicates
          eventDates = [...new Set(eventDates)]
        }
        dispatch({ type: EVENT_DOT_DATES, payload: eventDates })
      })
      .catch(err => {
        dispatch({ type: EVENT_DOT_DATES, payload: [] })
      })
  }
}
